import React from "react";
import "./BaseButton.css";

interface BaseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger";
  children: React.ReactNode;
}

const BaseButton: React.FC<BaseButtonProps> = ({
  variant = "primary",
  children,
  className = "",
  ...props
}) => {
  return (
    <button
      className={`base-button base-button--${variant} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
};

export default BaseButton;
